import { useState } from 'react';

import { IFetchCategory } from '@/services/allCategoryTypes';

const useAllCategory = () => {
  const [categoryList, setCategoryList] = useState<
    IFetchCategory['result']['content']
  >([] as IFetchCategory['result']['content']);
  const [categoryActiveTab, setCategoryActiveTab] = useState<number>(0);

  return {
    categoryList,
    setCategoryList,
    categoryActiveTab,
    setCategoryActiveTab,
  };
};

export default useAllCategory;
